<template>
  <div class="">
    <div class="row">
      <div class="col-lg-12">
        <div class="card bg-card mt-4">
          <div class="card-header">Información del Envío</div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-6 col-lg-3">
                <label class="required" for="cod_metodo_envio_id">Area Solicitante</label>
                <select v-model="formGestion.cod_metodo_envio_id" :disabled="formGestion.destinatario == ''"
                  @change="getDetalleMetodoEnvio && getDetalleMetodoEnvio()" class="form-control" id="cod_metodo_envio_id">
                  <option v-for="item in codigosMetodoEnvio" :key="item.id" :value="item.id">
                    {{ item.codigo }}
                  </option>
                </select>
              </div>
              <div class="form-group col-6 col-lg-3">
                <label class="required" for="id_tipo_envio">Tipo de Envío</label>
                <select v-model="formGestion.id_tipo_envio" class="form-control" id="id_tipo_envio">
                  <option v-for="item in tiposEnvio" :key="item.id" :value="item.id">
                    {{ item.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-6 col-lg-2">
                <label class="required" for="id_solicitudes_envio">Solicitud de Envío</label>
                <select v-model="formGestion.id_solicitudes_envio" class="form-control" id="id_solicitudes_envio">
                  <option v-for="item in solicitudesEnvio" :value="item.id" :key="item.id">
                    {{ item.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-lg-12">
                <label for="horas_extras">Observaciones</label>
                <textarea v-model="formGestion.observaciones" class="form-control no-resize" id="" cols="30" rows="5"></textarea>
              </div>
              <div class="form-group col-lg-12" v-if="formGestion.isEmergency">
                <label for="horas_extras" class="required">Motivo de la Emergencia/Urgencia</label>
                <textarea required v-model="formGestion.observaciones_emergencia" class="form-control no-resize" id="" cols="30" rows="5"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        Sección de Horarios
      </div>

      <div class="card-body py-4">
        <div class="row">

          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="fecha_salida">
              Fecha de Salida
            </label>
            <input type="date" v-model="formGestion.fecha_salida" class="form-control" id="fecha_salida" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="horario_salida">
              Hora de Salida
            </label>
            <input type="time" v-model="formGestion.horario_salida" class="form-control" id="horario_salida" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="fecha_entrada">
              Fecha de Entrega Programada
            </label>
            <input type="date" v-model="formGestion.fecha_entrada" class="form-control" id="fecha_entrada" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="fecha_entrada_maxima">
              Fecha de Entrega Máxima
            </label>
            <input type="date" v-model="formGestion.fecha_entrada_maxima" class="form-control"
              id="fecha_entrada_maxima" />
          </div>

          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="horario_entrega">
              Hora de Entrega Maxima
            </label>
            <input type="text" v-model="formGestion.horario_entrega" class="form-control" id="horario_entrega" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="fecha_entrega_real">
              Fecha Real de Entrega
            </label>
            <input type="date" v-model="formGestion.fecha_entrega_real" class="form-control" id="fecha_entrega_real" />
          </div>

          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="hora_llegada_origen_2">
              Hora de llegada al origen 1
            </label>
            <input type="time" v-model="formGestion.hora_llegada_origen" class="form-control"
              id="hora_llegada_origen_2" />
          </div>

          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="hora_salida_origen_2">
              Hora de salida del origen 1
            </label>
            <input type="time" v-model="formGestion.hora_salida_origen" class="form-control"
              id="hora_salida_origen_2" />
          </div>



          <!-- Hora de entrega al destino 1 -->
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="hora_entrega_destino_1">
              Hora de entrega al destino 1
            </label>
            <input type="time" v-model="formGestion.hora_entrega_destino_1" class="form-control"
              id="hora_entrega_destino_1" />
          </div>

          <!-- Fecha de entrega al destino 2 -->
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="fecha_entrega_destino_2">
              Fecha de entrega al destino 2
            </label>
            <input type="date" v-model="formGestion.fecha_entrega_destino_2" class="form-control"
              id="fecha_entrega_destino_2" />
          </div>

          <!-- Hora de entrega al destino 2 -->
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="hora_entrega_destino_2">
              Hora de entrega al destino 2
            </label>
            <input type="time" v-model="formGestion.hora_entrega_destino_2" class="form-control"
              id="hora_entrega_destino_2" />
          </div>


        </div>
      </div>
    </div>
    <div class="row">

      <div class="col-lg-12">
        <div class="card mt-3">
          <div class="card-header">
            Sección de Documentos
          </div>
          <div class="card-body py-3">
            <div class="row g-2 align-items-end p-2 rounded mb-2" style="background:#f8f9fa; border:1px solid #dee2e6;">
              <div class="form-group col-12 col-md-3">
                <label for="detalle_metodo_envio_id" class="form-label mb-1"><small>Detalle del Area Solicitante</small></label>
                <select v-model="formDocumento.detalle_metodo_envio_id" class="form-control form-control-sm" id="detalle_metodo_envio_id">
                  <option v-for="item in detallesMetodoEnvio" :key="item.id" :value="item.id">
                    {{ item.detalle }}
                  </option>
                </select>
              </div>
              <div class="form-group col-6 col-md-2">
                <label for="orden_compra" class="form-label mb-1"><small>N° Orden de Compra</small></label>
                <input type="text" v-model="formDocumento.orden_compra" class="form-control form-control-sm" id="orden_compra" />
              </div>
              <div class="form-group col-6 col-md-2">
                <label for="numero_factura" class="form-label mb-1"><small>N° Factura</small></label>
                <input type="text" v-model="formDocumento.numero_factura" class="form-control form-control-sm" id="numero_factura" />
              </div>
              <div class="form-group col-6 col-md-2">
                <label for="guia_transportista" class="form-label mb-1"><small>Guia Transportista</small></label>
                <input type="text" v-model="formDocumento.guia_transportista" class="form-control form-control-sm" id="guia_transportista" />
              </div>
              <div class="form-group col-6 col-md-2">
                <label for="documentos_extras" class="form-label mb-1"><small>Docs. extras</small></label>
                <input type="text" v-model="formDocumento.documentos_extras" class="form-control form-control-sm" id="documentos_extras" />
              </div>
              <div class="form-group col-12 col-md-auto d-flex align-items-end">
                <button class="btn btn-sm btn-info text-white w-100" @click="agregarDocumento()">
                  <i class="bi bi-plus-circle me-1"></i> Agregar
                </button>
              </div>
            </div>

            <!-- Tabla desktop -->
            <div class="row mt-3 d-none d-md-block">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered align-middle mb-0" style="font-size:0.85rem;">
                    <thead class="table-primary text-center">
                      <tr>
                        <th style="min-width:160px">Detalle Area</th>
                        <th style="min-width:130px">N° OC</th>
                        <th style="min-width:120px">N° Factura</th>
                        <th style="min-width:150px">OTM</th>
                        <th style="min-width:150px">Docs. Extras</th>
                        <th style="width:60px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!formGestion.documentos || formGestion.documentos.length === 0">
                        <td colspan="6" class="text-center text-muted py-3">Sin documentos agregados</td>
                      </tr>
                      <tr v-for="(doc, index) in formGestion.documentos" :key="index">
                        <td class="px-1 py-1">
                          <select v-model="doc.detalle_metodo_envio_id" class="form-control form-control-sm border-0 bg-transparent">
                            <option v-for="item in detallesMetodoEnvio" :key="item.id" :value="item.id">{{ item.detalle }}</option>
                          </select>
                        </td>
                        <td class="px-1 py-1"><input type="text" v-model="doc.orden_compra" class="form-control form-control-sm border-0 bg-transparent" /></td>
                        <td class="px-1 py-1"><input type="text" v-model="doc.numero_factura" class="form-control form-control-sm border-0 bg-transparent" /></td>
                        <td class="px-1 py-1"><input type="text" v-model="doc.otm" class="form-control form-control-sm border-0 bg-transparent" /></td>
                        <td class="px-1 py-1"><input type="text" v-model="doc.documentos_extras" class="form-control form-control-sm border-0 bg-transparent" /></td>
                        <td class="text-center px-1 py-1">
                          <button class="btn btn-sm btn-danger" @click="eliminarDocumento(index)">
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Cards mobile -->
            <div class="d-block d-md-none mt-3">
              <p v-if="!formGestion.documentos || formGestion.documentos.length === 0" class="text-muted text-center py-2">Sin documentos agregados</p>
              <div v-for="(doc, index) in formGestion.documentos" :key="index" class="card mb-2 border" style="border-radius:8px; overflow:hidden;">
                <div class="card-header py-2 d-flex justify-content-between align-items-center" style="background:#3f51b5!important; color:#fff!important; font-weight:normal!important; padding:8px 12px!important;">
                  <span class="fw-semibold small">Documento #{{ index + 1 }}</span>
                  <button class="btn btn-sm btn-danger py-0 px-2" @click="eliminarDocumento(index)"><i class="bi bi-trash"></i></button>
                </div>
                <div class="card-body py-2 px-3" style="background:#f8f9ff;">
                  <div class="row g-2" style="font-size:0.85rem;">
                    <div class="col-12">
                      <div class="text-muted" style="font-size:0.7rem; text-transform:uppercase;">Detalle Area</div>
                      <select v-model="doc.detalle_metodo_envio_id" class="form-control form-control-sm mt-1">
                        <option v-for="item in detallesMetodoEnvio" :key="item.id" :value="item.id">{{ item.detalle }}</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.7rem; text-transform:uppercase;">N° OC</div>
                      <input type="text" v-model="doc.orden_compra" class="form-control form-control-sm mt-1" />
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.7rem; text-transform:uppercase;">N° Factura</div>
                      <input type="text" v-model="doc.numero_factura" class="form-control form-control-sm mt-1" />
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.7rem; text-transform:uppercase;">Guia Transportista</div>
                      <input type="text" v-model="doc.guia_transportista" class="form-control form-control-sm mt-1" />
                    </div>
                    <div class="col-6">
                      <div class="text-muted" style="font-size:0.7rem; text-transform:uppercase;">Docs. Extras</div>
                      <input type="text" v-model="doc.documentos_extras" class="form-control form-control-sm mt-1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sección de Fletes -->
      <div class="col-lg-12">
        <div class="card mt-3 border-0 shadow-sm">
          <div class="card-header fw-semibold" style="background:linear-gradient(90deg,#e8eaf6,#f3f4fb); border-bottom:2px solid #c5cae9;">
            <i class="bi bi-cash-stack me-2 text-primary"></i>Sección de Fletes <span class="text-muted fw-normal">(Sin IGV)</span>
          </div>
          <div class="card-body py-3">
            <div class="row g-3">
              <div class="col-6 col-md-4 col-lg-2">
                <label class="form-label fw-semibold small mb-1">Flete</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-white">S/</span>
                  <input type="text" v-model="formGestion.flete" @change="actualizarGastos()" class="form-control" id="flete" placeholder="0.00" />
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <label class="form-label fw-semibold small mb-1">Flete Provincia</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-white">S/</span>
                  <input type="text" v-model="formGestion.falso_flete_provincia" @change="actualizarGastos()" class="form-control" id="falso_flete_provincia" placeholder="0.00" />
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <label class="form-label fw-semibold small mb-1">Flete Cancelación</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-white">S/</span>
                  <input type="text" v-model="formGestion.flete_cancelacion" @change="actualizarGastos()" class="form-control" id="flete_cancelacion" placeholder="0.00" />
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <label class="form-label fw-semibold small mb-1">Flete Visita Extra</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-white">S/</span>
                  <input type="text" v-model="formGestion.flete_visita_extra" @change="actualizarGastos()" class="form-control" id="flete_visita_extra" placeholder="0.00" />
                </div>
              </div>
              <div class="col-6 col-md-4 col-lg-2">
                <label class="form-label fw-semibold small mb-1">Flete Local/Urgencia</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-white">S/</span>
                  <input type="text" v-model="formGestion.flete_local_urgencia" @change="actualizarGastos()" class="form-control" id="flete_local_urgencia" placeholder="0.00" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de Gastos -->
      <div class="col-lg-8">
        <div class="card mt-3 border-0 shadow-sm">
          <div class="card-header fw-semibold" style="background:linear-gradient(90deg,#e8eaf6,#f3f4fb); border-bottom:2px solid #c5cae9;">
            <i class="bi bi-calculator me-2 text-primary"></i>Sección de Gastos <span class="text-muted fw-normal">(Sin IGV)</span>
          </div>
          <div class="card-body py-3">
            <div class="row g-3 align-items-end">
              <div class="col-lg-3">
                <label class="form-label fw-semibold small mb-1">Gastos Administrativos</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-white">S/</span>
                  <input type="text" v-model="formGestion.gastos_admin" @change="actualizarGastos()" class="form-control" id="gastos_admin" placeholder="0.00" />
                </div>
              </div>
              <div class="col-lg-3">
                <label class="form-label fw-semibold small mb-1">Gasto Total de Transporte</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text bg-success text-white">S/</span>
                  <input type="text" v-model="formGestion.gastos_total" readonly class="form-control fw-bold text-success" id="gastos_total" style="background:#f0faf0;" />
                </div>
              </div>
              <div class="col-lg-6">
                <label class="form-label fw-semibold small mb-1">Detalle de Gastos Administrativos</label>
                <input type="text" v-model="formGestion.detalle_gastos_admin" class="form-control form-control-sm" id="detalle_gastos_admin" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de Visitas Extras -->
      <div class="col-lg-4">
        <div class="card mt-3 border-0 shadow-sm">
          <div class="card-header fw-semibold" style="background:linear-gradient(90deg,#e8eaf6,#f3f4fb); border-bottom:2px solid #c5cae9;">
            <i class="bi bi-arrow-repeat me-2 text-primary"></i>Sección de Visitas Extras
          </div>
          <div class="card-body py-3">
            <div class="row g-3">
              <div class="col-12">
                <label class="form-label fw-semibold small mb-1">Causa de Visita Extra</label>
                <select v-model="formGestion.causa_visita" id="causa_visita" class="form-control form-control-sm">
                  <option disabled value="">Seleccione una opción</option>
                  <option>FALTA DE COORDINACION</option>
                  <option>OBSERVACION DE MERCADERIA</option>
                  <option>OTROS</option>
                  <option>NINGUNO</option>
                  <option>OBSERVACION DE DOCUMENTOS</option>
                </select>
              </div>
              <div class="col-12">
                <label class="form-label fw-semibold small mb-1">Detalle de la Causa</label>
                <input type="text" v-model="formGestion.detalle_causa_visita" class="form-control form-control-sm" id="detalle_causa_visita" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header">
        Sección de Juego de Documentos
      </div>



      <div class="card-body py-4">
        <div class="row">
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="cant_bultos">
              Cant. de Juegos de docs en origen
            </label>
            <input type="text" v-model="formGestion.cant_bultos" class="form-control" id="cant_bultos" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="cant_bultos_destino">
              Cant. de Juegos de docs en destino
            </label>
            <input type="text" v-model="formGestion.cant_bultos_destino" class="form-control"
              id="cant_bultos_destino" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="retorno_cargo_hojas">
              Retorno de cargo (N°hojas)
            </label>
            <input type="text" v-model="formGestion.retorno_cargo_hojas" class="form-control"
              id="retorno_cargo_hojas" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="retorno_cargo_origen_hojas">
              Retorno a origen (N° hojas)
            </label>
            <input type="text" v-model="formGestion.retorno_cargo_origen_hojas" class="form-control"
              id="retorno_cargo_origen_hojas" />
          </div>

          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="peso_bruto">
              Peso Bruto (KG)
            </label>
            <input type="text" v-model="formGestion.peso_bruto" class="form-control" id="peso_bruto" />
          </div>
        </div>
      </div>
    </div>


    <div class="card mt-3">
      <div class="card-header">
        Sección de Entrega
      </div>

      <div class="card-body py-4">
        <div class="row">
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="conformidad">
              Conformidad de entrega
            </label>
            <input type="text" v-model="formGestion.conformidad" class="form-control" id="conformidad" />
          </div>
          <div class="form-group mt-2 col-lg-4">
            <label class="required" for="id_causa_conformidad ">
              Causa de la Conformidad de entrega
            </label>
            <select name="" id="id_causa_conformidad" v-model="formGestion.id_causa_conformidad" class="form-control">
              <option v-for="item in causasConfomidad" :value="item.id" :key="item.id">{{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group mt-2 col-lg-6">
            <label class="required" for="detalle_causa_entrega">
              Detalle de causa de Conformidad de entrega
            </label>
            <input type="text" v-model="formGestion.detalle_causa_entrega" class="form-control"
              id="detalle_causa_entrega" />
          </div>
          <div class="form-group mt-2 col-6 col-lg-2">
            <label class="required" for="entrega_sin_danio">
              Entrega Completa y sin daño
            </label>
            <input type="text" v-model="formGestion.entrega_sin_danio" class="form-control" id="entrega_sin_danio" />
          </div>
          <div class="form-group mt-2 col-lg-4">
            <label class="required" for="id_causa_entrega ">
              Causa de la Entrega Completa y sin daño
            </label>
            <select name="" id="id_causa_entrega" v-model="formGestion.id_causa_entrega" class="form-control">
              <option v-for="item in causasEntregaCompleta" :value="item.id" :key="item.id">{{ item.nombre
              }}
              </option>
            </select>
          </div>
          <div class="form-group mt-2 col-lg-6">
            <label class="required" for="detalle_entrega_sin_danio">
              Detalle de Causa de la Entrega Completa y sin daño
            </label>
            <input type="text" v-model="formGestion.detalle_entrega_sin_danio" class="form-control"
              id="detalle_entrega_sin_danio" />
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-3">
      <div class="card-header">
        Sección de Cumplimiento
      </div>


      <div class="card-body py-4">
        <table class="table table-striped">
          <thead class="thead-light">
            <tr>
              <th style="width: 20%;"></th>
              <th>Entrega de documentos</th>
              <th>Cargos</th>
              <th>Retorno documentario</th>
            </tr>
          </thead>
          <tbody>
            <!-- Lead time prometido -->
            <tr>
              <td class="text-start"><label>Lead time prometido</label></td>
              <td>
                <input type="text" v-model="formGestion.lead_time_esperado" class="form-control"
                  placeholder="Lead time (Entrega)">
              </td>
              <td>
                <input type="text" v-model="formGestion.lead_time_prometido_cargos" class="form-control"
                  placeholder="Lead time (Cargos)">
              </td>
              <td>
                <input type="text" v-model="formGestion.lead_time_prometido_retorno" class="form-control"
                  placeholder="Lead time (Retorno)">
              </td>
            </tr>

            <!-- Cumplimiento del lead time -->
            <tr>
              <td class="text-start"><label>Cumplimiento del lead time</label></td>
              <td>
                <select v-model="formGestion.cumplimiento_lead_time" class="form-control select-35">
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </select>
              </td>
              <td>
                <select v-model="formGestion.cumplimiento_lead_time_subida_cargos" class="form-control select-35">
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </select>
              </td>
              <td>
                <select v-model="formGestion.cumplimiento_lead_time_retorno" class="form-control select-35">
                  <option value="SI">SI</option>
                  <option value="NO">NO</option>
                </select>
              </td>
            </tr>

            <!-- Causa del cumplimiento -->
            <tr>
              <td class="text-start"><label>Causa del cumplimiento</label></td>
              <td>
                <select v-model="formGestion.causa_cumplimiento_lead_time" class="form-control">
                  <option v-for="item in causasLlegadaDestino" :value="item.nombre" :key="item.id">{{
                    item.nombre }}</option>
                </select>
              </td>
              <td></td>
              <td>
                <select v-model="formGestion.causa_cumplimiento_lead_time_retorno" class="form-control">
                  <option v-for="item in causasRetornoDocumentario" :value="item.nombre" :key="item.id">{{
                    item.nombre }}</option>
                </select>
              </td>
            </tr>

            <!-- Detalle del cumplimiento -->
            <tr>
              <td class="text-start"><label>Detalle del cumplimiento</label></td>
              <td>
                <input type="text" v-model="formGestion.detalle_cumplimiento_llegada_destino" class="form-control"
                  placeholder="Detalle (Entrega)">
              </td>
            </tr>
            <tr>
              <td class="text-start">Estado de Retorno documentario</td>
              <td></td>
              <td></td>
              <td>
                <select name="" class="form-control" id="" v-model="formGestion.estado_retorno_cargos">
                  <option value="CUSTODIA">CUSTODIA</option>
                  <option value="EN TRANSITO">EN TRANSITO</option>
                  <option value="ENTREGADO">ENTREGADO</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="form-group mt-2 col-lg-12">
        <label>Observaciones</label>
        <textarea rows="10" v-model="formGestion.observaciones" class="form-control textarea-small"></textarea>
      </div>
    </div>


  </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'ShippingANWPage',
  props: {
    envio: Object,
  },

  data() {
    return {
      isLoading: true,
      tipoEnvio: this.$route.params.tipo_envio,
      modalDetalle: false,
      modalGestionANW: false,
      showModalArchivos: false,
      nombrePaquete: "",
      alto: "",
      ancho: "",
      largo: "",
      costoPorKg: "",
      pesoVolumetrico: "",
      pesoReal: "",
      costoPaquete: "",
      envioId: null,
      paquetes: [],
      estadosEnvio: [],
      causasConfomidad: [],
      causasEntregaCompleta: [],
      causasRetornoDocumentario: [
        { "id": 1, "nombre": "NINGUNO" },
        { "id": 2, "nombre": "DEMORA POR ANW" },
        { "id": 3, "nombre": "DEMORA POR CASO FORTUITO" },
        { "id": 4, "nombre": "DEMORA POR EL CLIENTE DE DRAEGER" }
      ],
      causasLlegadaDestino: [
        { "id": 1, "nombre": "NINGUNO" },
        { "id": 2, "nombre": "DEMORA POR CASO FORTUITO" },
        { "id": 3, "nombre": "DEMORA POR ANW" },
        { "id": 4, "nombre": "DEMORA POR CLIENTE DE DRAEGER" },
        { "id": 5, "nombre": "DEMORA POR DRAEGER" }
      ],
      tiposEnvio: [],
      solicitudesEnvio: [],
      codigosMetodoEnvio: [],
      detallesMetodoEnvio: [],
      formDocumento: {
        detalle_metodo_envio_id: '',
        orden_compra: '',
        numero_factura: '',
        guia_transportista: '',
        documentos_extras: ''
      },
      formGestion: {
        guia_transporista: "",
        lead_time_prometido_cargos: "4 HORAS",
        lead_time_prometido_retorno: "5 DÍAS"
      },
      filtros: {
        tipo_paquete: "documentos",
        ruc: '',
        razon_social: '',
        cliente_final: '',
        pedido: '',
        guia: '',
        serie_guia: '',
        fecha_inicio: '',
        fecha_fin: '',
        id_modalidades_envio: '',
      },
      comentario: '',
      detalleEnvio: {},
      envios: [],
      empresas: [
        { id: 1, nombre: 'Empresa A' },
        { id: 2, nombre: 'Empresa B' },
      ],
      tipoUnidades: [
        { id: 3, tipo_unidad: 'Camión 10T' },
        { id: 4, tipo_unidad: 'Camión 20T' },
      ],
      archivos: [],
      nuevoArchivo: {
        tipo: '',
        archivo: null,
        nombre: '',
        comentario: '',
        url: null,
      },
      dragging: false,
    }
  },
  watch: {
    costoTotal(newVal) {
      this.formGestion.flete = newVal
      this.actualizarGastos()
    }
  },
  computed: {
    totalPaquetes() {
      return this.paquetes.length
    },
    totalPesoVolumetrico() {
      return this.paquetes.reduce((total, p) => total + p.pesoVolumetrico, 0)
    },
    totalPesoReal() {
      return this.paquetes.reduce((total, p) => total + p.peso, 0)
    },
    costoServicio() {
      return this.paquetes.reduce((total, p) => total + p.costo, 0);
    },
    costoVerificacion() {
      return this.costoServicio * 0.5;
    },
    costoTotal() {
      return Number((this.costoServicio + this.costoVerificacion).toFixed(2));
    }
  },
  mounted() {
    this.formGestion = this.envio
    this.formGestion.flete=this.envio.precio_servicio
    this.$nextTick(() => this.actualizarGastos())
    this.getEstadosEnvio()
    this.getCausasConformidad()
    this.getCausasEntregaCompleta()
    this.buscarPrecioConsolidado()
    this.getTipoEnvio()
    this.getSolicitudesEnvio()
    this.getCodigoMetodoEnvio()
    this.getDetalleMetodoEnvio()
  },
  methods: {
    agregarDocumento() {
      if (this.formDocumento.guia_transportista) {
        this.formGestion.documentos.push({ ...this.formDocumento })
        this.formDocumento = {
          detalle_metodo_envio_id: '',
          orden_compra: '',
          numero_factura: '',
          guia_transportista: '',
          documentos_extras: ''
        }
      } else {
        alert('Debe ingresar al menos la guía de transportista')
      }
    },
    eliminarDocumento(index) {
      this.formGestion.documentos.splice(index, 1)
    },
    actualizarGastos() {
      const gastos_admin = Number(this.formGestion.gastos_admin) || 0
      const flete = Number(this.formGestion.flete) || 0
      const falso_flete_provincia = Number(this.formGestion.falso_flete_provincia) || 0
      const flete_cancelacion = Number(this.formGestion.flete_cancelacion) || 0
      const flete_visita_extra = Number(this.formGestion.flete_visita_extra) || 0
      const flete_local_urgencia = Number(this.formGestion.flete_local_urgencia) || 0
      this.formGestion.gastos_total =
        gastos_admin + flete + falso_flete_provincia +
        flete_cancelacion + flete_visita_extra + flete_local_urgencia
    },
                async getCodigoMetodoEnvio() {
                  try {
                    const response = await axios.get('cod-metodo-envio')
                    this.codigosMetodoEnvio = response.data
                  } catch (error) {
                    console.error('Error cargando códigos de método de envío:', error)
                  }
                },
                async getDetalleMetodoEnvio() {
                  try {
                    if (!this.formGestion.cod_metodo_envio_id) {
                      this.detallesMetodoEnvio = [];
                      return;
                    }
                    const response = await axios.get(`detalle-envio-by-codigo/${this.formGestion.cod_metodo_envio_id}`);
                    this.detallesMetodoEnvio = response.data;
                  } catch (error) {
                    console.error('Error cargando detalles de método de envío:', error);
                    this.detallesMetodoEnvio = [];
                  }
                },
            async getSolicitudesEnvio() {
              try {
                const response = await axios.get('solicitudes-envio')
                this.solicitudesEnvio = response.data
              } catch (error) {
                console.error('Error cargando solicitudes de envío:', error)
              }
            },
        async getTipoEnvio() {
          if (this.formGestion.horario_salida == null || this.formGestion.fecha_salida == null) { return; }
          try {
            const ids = this.calcularIdsTipoEnvio();
            const response = await axios.get('tipos-envio', { params: { ids } });
            this.tiposEnvio = response.data;
            this.formGestion.id_tipo_envio = ids[0];
          } catch (error) {
            console.error('Error cargando tipos de envío:', error);
          }
        },
        calcularIdsTipoEnvio() {
          // Implementa la lógica real aquí
          // Ejemplo: return [1,2,3];
          return [1];
        },
    async getCausasConformidad() {
      try {
        const { data } = await axios.get('causas-incidencia')
        this.causasConfomidad = data
        this.isLoading = false;
      } catch (error) {
        console.error('Error al getCausasConformidad', error)
      }
    },
    async getCausasEntregaCompleta() {
      try {
        const { data } = await axios.get('causas-entrega-completa')
        this.causasEntregaCompleta = data
        this.isLoading = false;
      } catch (error) {
        console.error('Error al causasEntregaCompleta', error)
      }
    },

    formatFecha(fecha) {
      if (!fecha) return ''
      const [year, month, day] = fecha.split('-')
      return new Date(year, month - 1, day).toLocaleDateString('es-PE', {
        dateStyle: 'short',
      })
    },

    abrirGestionarModal(item) {
      this.formGestion = item
      this.formGestion.lead_time_prometido_cargos = "4 HORAS"
      this.formGestion.lead_time_prometido_retorno = "5 DÍAS"
      this.modalGestionANW = true
      this.buscarPrecioConsolidado()
    },
    cerrarDetalle() {
      this.modalDetalle = false
    },
    obtenerNombreEmpresa(id) {
      return this.empresas.find((e) => e.id === id)?.nombre || 'No especificado'
    },
    obtenerTipoUnidad(id) {
      return (
        this.tipoUnidades.find((t) => t.id === id)?.tipo_unidad ||
        'No especificado'
      )
    },

    async buscarPrecioConsolidado() {
      try {
        let url = `precio-consolidado/peso_volumen/${this.formGestion.id_distrito_destinatario}`
        const response = await axios.get(url)
        const data = response.data
        this.costoPorKg = data.costo
      } catch (error) {
        console.error(`Error al cargar precios`, error)
      }
    },
    calcularCosto() {
      this.pesoVolumetrico = (this.alto * this.ancho * this.largo) / 5000
      let mayorPeso = Math.max(this.pesoReal, this.pesoVolumetrico)
      this.costoPaquete = parseFloat((mayorPeso * this.costoPorKg).toFixed(2))
    },

    agregarPaquete() {
      if (
        !this.nombrePaquete ||
        !this.alto ||
        !this.ancho ||
        !this.largo ||
        !this.pesoReal
      ) {
        alert('Completa todos los campos antes de agregar el paquete.')
        return
      }

      this.paquetes.push({
        nombre: this.nombrePaquete,
        alto: this.alto,
        ancho: this.ancho,
        largo: this.largo,
        peso: this.pesoReal,
        pesoVolumetrico: this.pesoVolumetrico,
        costo: this.costoPaquete,
      })

      // Limpiar los campos
      this.nombrePaquete = ''
      this.alto = ''
      this.ancho = ''
      this.largo = ''
      this.pesoReal = ''
      this.pesoVolumetrico = 0
      this.costoPaquete = 0
    },
    eliminarPaquete(index) {
      this.paquetes.splice(index, 1)
    },
    async getEstadosEnvio() {
      this.isLoading = true;
      const { data } = await axios.get('estados-envio')
      this.estadosEnvio = data
      this.isLoading = false;
    },
    async actualizarEnvio(accion) {
      try {
        await axios.get(`${accion}-envio/${this.detalleEnvio.id_envio}`)
        this.cerrarDetalle()
        this.buscarEnvios()
        Swal.fire({
          icon: 'success',
          title: 'Envío Actualizado',
          text: 'Los datos se han actualizado correctamente.',
        })
      } catch (error) {
        console.error(`Error al ${accion} envío`, error)
      }
    },
    getBadgeClass(estado) {
      return (
        {
          PENDIENTE: 'badge bg-warning',
          ACEPTADO: 'badge bg-success',
          RECHAZADO: 'badge bg-danger',
        }[estado] || 'badge bg-secondary'
      )
    },
    limpiarFiltros() {
      Object.keys(this.filtros).forEach(
        (key) =>
          (this.filtros[key] = key === 'id_modalidades_envio' ? '3' : ''),
      )
      this.buscarEnvios()
    },
    submitDesdePadre() {
      return this.guardarGestion();
    },
    async guardarGestion() {
      console.log("formGestion", this.formGestion)
      try {
        await axios.post('gestion-anw', this.formGestion);
        Swal.fire({
          icon: 'success',
          title: 'Atención',
          text: 'Los datos se actualizaron correctamente',
        })
      } catch (error) {
        console.error('Error al guardar los datos:', error);
      }
    },

  },
}
</script>

<style scoped>
.modal.fade.show {
  display: block;
}

.modal.show {
  background: rgba(0, 0, 0, 0.5);
}


.badge {
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 5px;
}

.table-font-small {
  font-size: 0.75rem;
}

.table {
  table-layout: fixed;
  width: 100%;
}

.dropdown-menu {
  min-width: 180px;
}

.dropdown-item i {
  margin-right: 8px;
}

.custom-dropdown {
  position: absolute !important;
  /* Permite que se desplace sobre otras filas */
  z-index: 1050 !important;
  /* Asegura que esté sobre otros elementos */
  left: auto !important;
  /* Evita que se recorte en la tabla */
  right: 0 !important;
  /* Alinea correctamente */
}

.table-responsive {
  overflow: visible !important;
  /* Permite que el dropdown no se esconda */
}

.dropdown-menu.show {
  position: absolute !important;
  z-index: 1050 !important;
  will-change: transform;
}

.dropzone {
  border: 2px dashed #007bff;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.3s;
}

.dropzone:hover,
.dropzone.drop-hover {
  background: rgba(0, 123, 255, 0.1);
}

.dropzone-content i {
  color: #007bff;
}

.dropzone-preview img {
  max-width: 100px;
  margin-top: 10px;
}

.swal2-container {
  z-index: 9999 !important;
}

.textarea-small {
  height: 100px;
}

.modal {
  z-index: 90;
}

#modalGestionANW label {
  font-size: 0.75rem;
}

/* Detalle */
</style>